import type { DitherStaticState } from "./dither-static.types";

export const ditherStaticStateCache = new Map<string, DitherStaticState>();
